import React, { useState, useEffect, useContext } from "react";
import { Modal, Button } from "antd";
import { useFlutterwave } from "flutterwave-react-v3";
// import axios from "axios";
import { PlayContext } from "../../App";
import { Link, useHistory } from "react-router-dom";
import "./Navbar.css";
import ModalPopUp from "../Modal/Modal";
import axios from "../../Utils/axios"
import {
  sendOtpURL,
  confirmOtpURL,
  recargeWallet,
  getWallet,
  
} from "../../Utils/apis";
import { notification } from "antd";

const Navbar = () => {
  const { open, toggleOpen } = useContext(PlayContext);
  // flutter wave logic starts
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    reference: "",
    wallet: "",
    flutterwaveVisible: false,
  });
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState("");

  const [reference, setReference] = useState("");
  const [wallet, setWallet] = useState({
    phone: "",
    balance: "",
  });

  let history = useHistory();

  const logout = () => {
    localStorage.removeItem("authed");
    localStorage.removeItem("token");
    history.push("/");
    history.push("/");
  };

  function refreshPage() {
    window.location.reload(false);
  }

  const openCustomErrorNotification = (msg) => {
    const args = {
      message: "Error",
      description: msg,
      duration: 5,
    };
    notification.open(args);
  };

  const openCustomSuccessNotification = (msg) => {
    const args = {
      message: "Error",
      description: msg,
      duration: 5,
    };
    notification.open(args);
  };

  useEffect(() => {
    if (localStorage.getItem("authed") == "authenticated") {
      balance();
    }
  }, []);

  const number = localStorage.getItem("msisdn");

  const config = {
    public_key: "FLWPUBK-df08235033ae529c46e438265e6c2004-X",
    tx_ref: Date.now(),
    amount: amount,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      email: email,
      phonenumber: phone,
      name: name,
    },
    customizations: {
      title: "Spinwheel Points Topup",
      description: "Payment for spinwheel points",
      logo: "https://cdn5.vectorstock.com/i/thumb-large/98/94/fortune-wheel-game-logo-casino-slot-machine-vector-31539894.jpg",
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  //checking wallet balance starts

  const balance = () => {
    setLoading(true);

    axios({
      method: "post",
      url: getWallet,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        msisdn: localStorage.getItem("msisdn"),
      },
    })
      .then((res) => {
        setWallet({
          phone: res.data.customer.msisdn,
          amount: res.data.wallet_balance,
        });
        localStorage.setItem("wallet_balance", res.data.wallet_balance);
        // check if its higher than 50 too
        if (res.data.wallet_balance > -50) {
          toggleOpen();
        }
        console.log(res.data);
        // console.log(res.data.customermessage.tx_ref);
        // console.log(data);
        setTimeout(() => {
          clearData();
        }, 1000);
      })
      .catch((error) => {
        console.log({ error });
      });
  };
  // checking wallet balance ends

  const clearData = () => {
    setAmount("");
    setEmail("");
    setPhone("");
    setName("");
  };

  const headers = {
    "auth-token": localStorage.getItem("sudha-auth-token"),
  };

  // handle top up function starts
  const handleTopup = (txnRef) => {
    axios({
      method: "post",
      url: recargeWallet,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        msisdn: wallet.phone,
        email: email,
        amount: amount,
        reference: txnRef,
      },
    })
      .then((res) => {
        openCustomSuccessNotification("Topup Made Successfully");
        setTimeout(() => {
          console.log("Topup made successflly");
          clearData();
          refreshPage();
        }, 2000);
      })
      .catch((error) => {
        openCustomErrorNotification("Topup Not Successfull");
        setTimeout(() => {
          console.log("topup not completed");
          clearData();
          // refreshPage()
        }, 2000);
      });
  };

  // handle top-up logic ends

  // flutter wave logic

  // modal logics start
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setVisible(true);
      setLoading(true);
    }, 3000);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  // const logged_in_number = state.msisdn;

  return (
    <div className="">
      <div className="container">
        <br></br>
        <nav class="navbar navbar-expand-lg navbar-dark navbar-custom">
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
              <li class="nav-item active">
                <Link class="nav-link" to="/">
                  Home <span class="sr-only">(current)</span>
                </Link>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/how-to-play">
                  How to Play
                </Link>
              </li>
              <li class="nav-item">
                <Link class="nav-link pl-2" to="/prizes">
                     Prizes
                </Link>
              </li>
              <li class="nav-item">
                <div class="">
                  <div class="dropdown mx-0">
                    <article
                      class="btn nav-link mx-0 font-weight-bold dropdown-toggle"
                      href="#"
                      role="button"
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Winnings
                    </article>

                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuLink"
                    >
                      {localStorage.getItem("authed") === "authenticated" ? (
                        <Link class="dropdown-item" to="/my-winnings">
                          My Winnings
                        </Link>
                      ) : null}
                      <Link class="dropdown-item" to="/recent-winners">
                        Recent Winners
                      </Link>
                      <Link class="dropdown-item" to="/terms-and-conditions">
                        Terms And Conditions
                      </Link>
                      <Link class="dropdown-item" to="/contact-us">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </li>

              {localStorage.getItem("authed") === "authenticated" ? (
                <>
                  <li class="nav-item float-right pull-right">
                    {/* <Button type="primary" onClick={showModal}>
                  Open Modal with customized footer
                </Button> */}
                    <Link class="nav-link float-right pull-right">
                      <button
                        onClick={showModal}
                        className="btn btn-sm border-white text-white font-weight-bold rounded text-capitalize"
                      >
                        top-up
                      </button>
                    </Link>
                  </li>

                  <li class="nav-item float-right pull-right ">
                    <span class="nav-link text-white shadow">
                      0{wallet.phone}
                    </span>
                  </li>
                  <li class="nav-item mt-2">
                    <span class="nav-link badge badge-success p-2 text-white">
                      points : {wallet.amount}
                    </span>
                  </li>
                  <li
                    class="nav-item float-right pull-right font-weight-bold mt-2"
                    onClick={logout}
                  >
                    <Button class="nav-link">logout</Button>
                  </li>
                </>
              ) : null}
            </ul>
          </div>
        </nav>
      </div>
      <Modal
        visible={visible}
        title="Top-up, spin, and win"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleFlutterPayment({
              callback: (response) => {
                handleTopup(response.tx_ref);
              },
              onClose: () => {
                handleTopup();
              },
            });
          }}
        >
          <div class="form-group">
            <label style={{ color: "purple" }} for="name">
              Name
            </label>
            <input
              type="text"
              class="form-control"
              id="name"
              placeholder="Enter Name"
              value={name}
              required
              onChange={(e) => setName(e.target.value)}
            />
            <br />
            <label style={{ color: "purple" }} for="exampleInputEmail1">
              Email address
            </label>
            <input
              type="email"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <br />
            <label style={{ color: "purple" }} for="name">
              Phone
            </label>
            <input
              type="text"
              class="form-control"
              id="phone"
              placeholder="Enter Phone number"
              value={`0${wallet.phone}`}
              readOnly
              required
            />
            <br />
            <label style={{ color: "purple" }} for="phone">
              Amount
            </label>
            <input
              type="number"
              class="form-control"
              id="amount"
              placeholder="Enter Amount"
              value={amount}
              min={250}
              onChange={(e) => setAmount(e.target.value)}
              required
            />
          </div>
          <div className="text-center">
            <div>
              <button
                type="submit"
                className="btn button-submit text-dark p-2 btn-sm pl-2 text-center font-weight-bold text-uppercase"
              >
                Pay with Flutterwave
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default Navbar;
